<form nz-form [formGroup]="filterForm" (ngSubmit)="onSearch()">
    <div nz-row [nzGutter]="16" class="filter-row">
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5">
            <label for="providerPplId" class="field-header">Provider PPL ID</label>
            <input nz-input id="providerPplId" formControlName="providerPplId" placeholder="Provider PPL ID" />
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5">
            <label for="participantPplId" class="field-header">Participant PPL ID</label>
            <input nz-input id="participantPplId" formControlName="participantPplId" placeholder="Participant PPL ID" />
        </div>
        <div nz-col class="filter-actions">
            <ppl-button label="Search" icon="fa fa-search" [customClass]="'primary-button'" [iconPosition]="'left'"
                type="submit"></ppl-button>
            <ppl-button label="Clear" [customClass]="'ghost-button'" (click)="onClear()"></ppl-button>
        </div>
    </div>
    @if (showRequiredError) {
    <div class="error-message">Please enter a Provider PPL ID or a Participant PPL ID.</div>
    }
</form>
